// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"78":"3151178c","476":"50a464c6","618":"3a2a35a8","715":"3584a723","808":"aa6d8cca"}[chunkId] + ".css";
};